import { createIsomorphicFn } from "@tanstack/react-start";

import type { PagePreviewInput } from "@/lib/pagePreview";
import {
  buildSeoMetaTags,
  type MetaTag,
  type SeoMetaData,
  type SeoMetaOptions,
} from "@/lib/seo-meta";

/** Generated social images belong to direct SSR responses, not client navigation. */
export const buildPagePreviewMetaTags = createIsomorphicFn()
  .server(
    async (
      data: SeoMetaData,
      options: SeoMetaOptions,
      preview: Pick<PagePreviewInput, "locale">,
    ): Promise<MetaTag[]> => {
      const { buildServerPagePreviewMetaTags } =
        await import("@/server/internal-media/buildPagePreviewMetaTags.server");
      return buildServerPagePreviewMetaTags(data, options, preview);
    },
  )
  .client(
    async (
      data: SeoMetaData,
      options: SeoMetaOptions,
      _preview: Pick<PagePreviewInput, "locale">,
    ): Promise<MetaTag[]> =>
      buildSeoMetaTags(
        { ...data, imageUrl: null },
        {
          ...options,
          openGraph: options.openGraph === false ? false : { ...options.openGraph, image: false },
          twitter: options.twitter === false ? false : { ...options.twitter, includeImage: false },
        },
      ),
  );
